import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, CircularProgress, Chip, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ChatTab from './ChatTab';
import axios from 'axios';

const axiosInst = axios.create({ baseURL: '/api' });
axiosInst.interceptors.request.use(c => {
  const t = localStorage.getItem('dashboard_token');
  if (t) c.headers['Authorization'] = 'Bearer ' + t;
  return c;
});

export default function SupportPage() {
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);

  const loadChats = () => axiosInst.get('/chats')
    .then(r => { setChats(r.data); setLoading(false); })
    .catch(() => setLoading(false));

  useEffect(() => { loadChats(); const t = setInterval(loadChats, 10000); return () => clearInterval(t); }, []);

  const totalUnread = chats.reduce((s, c) => s + (c.unread_count || 0), 0);

  if (loading) return <CircularProgress sx={{ color:'var(--ac1, #7c4dff)', m:4 }}/>;

  if (selectedUser) return (
    <Box>
      <Typography variant='h6' sx={{ color:'#fff', mb:2 }}>💬 @{selectedUser.telegram_username}</Typography>
      <Paper sx={{ bgcolor:'#1a1a2e', border:'1px solid #333', p:0 }}>
        <ChatTab userId={selectedUser.id} onBack={() => { setSelectedUser(null); loadChats(); }}/>
      </Paper>
    </Box>
  );

  return (
    <Box>
      <Box sx={{ display:'flex', alignItems:'center', gap:2, mb:3 }}>
        <Typography variant='h5' sx={{ color:'#fff', fontWeight:'bold' }}>💬 Підтримка</Typography>
        {totalUnread > 0 && <Chip label={totalUnread + ' нових'} sx={{ bgcolor:'#f44336', color:'#fff' }}/>}
        <Chip label='🔄 10 сек' sx={{ bgcolor:'rgba(33,150,243,0.2)', color:'#2196f3' }}/>
      </Box>
      {chats.length === 0 ? (
        <Paper sx={{ bgcolor:'#1a1a2e', border:'1px solid #333', p:4, textAlign:'center' }}>
          <Typography sx={{ color:'#555' }}>😴 Немає звернень</Typography>
        </Paper>
      ) : (
        <Box sx={{ display:'flex', flexDirection:'column', gap:1 }}>
          {chats.map(chat => (
            <Paper key={chat.id} onClick={() => setSelectedUser(chat)}
              sx={{ bgcolor:'#1a1a2e', border:'1px solid '+(chat.unread_count>0?'#f44336':'#333'),
                borderRadius:2, p:2, cursor:'pointer', '&:hover':{bgcolor:'#1e1e35'} }}>
              <Box sx={{ display:'flex', alignItems:'center', gap:2 }}>
                <Avatar sx={{ bgcolor: chat.unread_count>0?'#f44336':'#333', width:40, height:40 }}>
                  {(chat.telegram_username||'?')[0].toUpperCase()}
                </Avatar>
                <Box sx={{ flexGrow:1, minWidth:0 }}>
                  <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <Typography variant='body1' sx={{ color:'#fff', fontWeight: chat.unread_count>0?'bold':'normal' }}>
                      @{chat.telegram_username || '?'}
                      {chat.lang_ui && <Typography component='span' variant='caption' sx={{ color:'#666', ml:1 }}>({chat.lang_ui})</Typography>}
                    </Typography>
                    <Typography variant='caption' sx={{ color:'#555', flexShrink:0 }}>
                      {chat.last_message_at ? new Date(chat.last_message_at).toLocaleString('uk-UA',{hour:'2-digit',minute:'2-digit',day:'2-digit',month:'2-digit'}) : ''}
                    </Typography>
                  </Box>
                  <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <Typography variant='caption' sx={{ color:'#888', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:'80%' }}>
                      {chat.last_direction==='from_admin'?'Ви: ':''}{chat.last_message?.substring(0,60)}
                    </Typography>
                    {chat.unread_count > 0 && <Chip label={chat.unread_count} size='small' sx={{ bgcolor:'#f44336', color:'#fff', height:20, fontSize:11, flexShrink:0 }}/>}
                  </Box>
                </Box>
              </Box>
            </Paper>
          ))}
        </Box>
      )}
    </Box>
  );
}
